import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

// Link that will navigate to the specified path and add source location's
// pathname to a source parameter in target location's state.
const SourceLink = ({ children, to, ...other }) => {
  const { pathname: source } = useLocation();

  let newLink;
  if (typeof to === 'string') {
    newLink = { pathname: to, state: { source } };
  } else {
    newLink = { ...to, state: { ...to.state, source } };
  }

  return <Link {...other} to={newLink}>{children}</Link>;
};

SourceLink.propTypes = {
  children: PropTypes.node,
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

export default SourceLink;
